import { render, staticRenderFns } from "./mainIndex.vue?vue&type=template&id=bf317f6c&scoped=true"
import script from "./mainIndex.vue?vue&type=script&lang=js"
export * from "./mainIndex.vue?vue&type=script&lang=js"
import style0 from "./mainIndex.vue?vue&type=style&index=0&id=bf317f6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf317f6c",
  null
  
)

export default component.exports